function stefna_depends(dependingElement, openClass, debugEnabled) {
	if (typeof debugEnabled === 'undefined') {
		debugEnabled = false;
	}
	if (!dependingElement) {
		return;
	}

	init(dependingElement);

	function findDependee(dep_field, dep_value) {
		var values = dep_value.split(' ');
		var selectors = ['#' + dep_field];
		values.forEach(function (value) {
			selectors.push('#' + dep_field + '-' + value);
		});
		var sel = selectors.join(', ');
		debug('Finding dependees', {
			'f': dep_field,
			'v': dep_value,
			'sel': sel,
		});
		return document.querySelectorAll(sel);
	}

	function addListener(dependee) {
		dependee.addEventListener('change', dependeeChange);
	}

	function dependeeChange() {
		debug('Dependee Change', {
			'value': this.value,
			'id': this.id,
			'type': this.constructor.name,
		});

		var value = this.value;
		var name = this.id;

		if (this instanceof HTMLSelectElement) {
			value = this[this.selectedIndex].value;
		}
		else if (this instanceof HTMLInputElement && this.type === 'radio') {
			name = name.replace(/-[^-]+$/, '');
		}

		// ~= contains word
		var sel = '[data-depends_field~="' + name + '"]';
		debug('Trying to find depenands', {
			'sel': sel,
			'value': value,
			'name': name,
		});

		var regex = new RegExp('\\b' + value + '\\b');

		document.querySelectorAll(sel).forEach(function (el) {
			var depValue = el.dataset['depends_value'];
			debug('Hmm, ok should I hide or open', {
				'id': el.id,
				'class': el.className,
				'value': value,
				'dep_value': depValue,
				'regex': regex.toString(),
			});
			if (depValue && depValue.match(regex)) {
				el.classList.add(openClass);
			}
			else {
				el.classList.remove(openClass);
			}
		});
	}

	function hookDependee(dependee) {
		if (!dependee.stefnaDependsHooked) {
			dependee.stefnaDependsHooked = true;
			debug('Hooking to Dependee', {
				'id': dependee.id,
				'class': dependee.className
			});
			addListener(dependee);
			// Make sure we hook into same-name-elements (like radio) even if they don't have "value"
			var otherElements = dependee.form.elements[dependee.name];
			for (var i = 0, c = otherElements.length; i < c; i++) {
				hookDependee(otherElements[i]);
			}
		}
	}

	function init(dependingElement) {
		var dep_field = dependingElement.dataset['depends_field'];
		var dep_value = dependingElement.dataset['depends_value'];
		debug('Trying to Depend', {
			'field': dep_field,
			'value': dep_value,
			'id': dependingElement.id,
		});

		if (!dep_field || !dep_value) {
			return;
		}

		findDependee(dep_field, dep_value).forEach(hookDependee);
	}

	function debug(msg, context) {
		if (debugEnabled) {
			console.log(msg, context);
		}
	}
}
